var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgManageDeviceTitle = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15H7C6.46957 15 5.96086 15.2107 5.58579 15.5858C5.21071 15.9609 5 16.4696 5 17V19",
    stroke: "#03002F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15H21C21.5304 15 22.0391 15.2107 22.4142 15.5858C22.7893 15.9609 23 16.4696 23 17V19",
    stroke: "#03002F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 33H7C6.46957 33 5.96086 32.7893 5.58579 32.4142C5.21071 32.0391 5 31.5304 5 31V29",
    stroke: "#03002F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 33H21C21.5304 33 22.0391 32.7893 22.4142 32.4142C22.7893 32.0391 23 31.5304 23 31V29",
    stroke: "#03002F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19C12.64 19 11.6 20.0833 11.6 21.5V22.3333C10.72 22.3333 10 23.0833 10 24V27.3333C10 28.25 10.72 29 11.6 29H16.4C17.28 29 18 28.25 18 27.3333V24C18 23.0833 17.28 22.3333 16.4 22.3333V21.5C16.4 20.0833 15.36 19 14 19ZM14.8 22.3333H13.2V21.5C13.2 21 13.52 20.6667 14 20.6667C14.48 20.6667 14.8 21 14.8 21.5V22.3333Z",
    fill: "#C59331"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 20,
    fill: "#EFF2F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.81 13H20.81C19.71 13 18.81 13.9 18.81 15V18H20.81V16H30.81V32H20.81V30H18.81V33C18.81 34.1 19.71 35 20.81 35H30.81C31.91 35 32.81 34.1 32.81 33V15C32.81 13.9 31.91 13 30.81 13ZM18.82 25.47L16.27 22.92L15 24.19L18.81 28L26 20.81L24.73 19.54L18.82 25.47Z",
    fill: "#03002F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.82 25.4691L16.27 22.9191L15 24.1891L18.81 27.9991L26 20.8091L24.73 19.5391L18.82 25.4691Z",
    fill: "#C59331"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgManageDeviceTitle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/manageDeviceTitle.0e6846c4de24b92db0f154fbde5f2f7a.svg";